import { render, staticRenderFns } from "./CouponHome.vue?vue&type=template&id=5cbb2b96&"
import script from "./CouponHome.vue?vue&type=script&lang=js&"
export * from "./CouponHome.vue?vue&type=script&lang=js&"
import style0 from "./CouponHome.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports